export default __webpack_public_path__ + "static/share-c02e983b6d7f11892c4287b55ee4939b.jpg";